module.exports = "../fonts/Lato-Regular.eot";